import React, { useState } from 'react';
import Button from '@mui/material/Button';
import UserFields from './UserFields'; // Adjust the import path as needed
import './CreateUser.css'; // Ensure the CSS is loaded

const CreateUser = ({ onCreateUser }) => {
 
  return (
    <div className="add-user-container">
      <UserFields onCreateUser={onCreateUser} />
    </div>
  );
};

export default CreateUser;
